import { render, staticRenderFns } from "./WorkersBulkAdd.vue?vue&type=template&id=627a924a&scoped=true"
import script from "./WorkersBulkAdd.vue?vue&type=script&lang=ts"
export * from "./WorkersBulkAdd.vue?vue&type=script&lang=ts"
import style0 from "./WorkersBulkAdd.vue?vue&type=style&index=0&id=627a924a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627a924a",
  null
  
)

export default component.exports